/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum InvoiceChallengeType {
  ApplyQuote = "ApplyQuote",
  ApplyRate = "ApplyRate",
  IncorrectFreightClass = "IncorrectFreightClass",
  ReviewFuelSurcharge = "ReviewFuelSurcharge",
  JustifyAdditionalWeight = "JustifyAdditionalWeight",
  JustifyDimensions = "JustifyDimensions",
  RemoveDeliveryAppointmentFee = "RemoveDeliveryAppointmentFee",
  RemoveNotifyPriorToDeliveryFee = "RemoveNotifyPriorToDeliveryFee",
  RemoveResidentialFee = "RemoveResidentialFee",
  RemoveLimitedAccessPickupFee = "RemoveLimitedAccessPickupFee",
  RemoveLimitedAccessDeliveryFee = "RemoveLimitedAccessDeliveryFee",
  RemovePickupLiftgateFee = "RemovePickupLiftgateFee",
  RemoveDeliveryLiftgateFee = "RemoveDeliveryLiftgateFee",
  RemoveInsidePickupFee = "RemoveInsidePickupFee",
  RemoveInsideDeliveryFee = "RemoveInsideDeliveryFee",
  RemoveDetentionFee = "RemoveDetentionFee",
  RemoveBondFee = "RemoveBondFee",
  RemoveStorageFee = "RemoveStorageFee",
  RemoveRedeliveryFee = "RemoveRedeliveryFee",
  ProvidePhotos = "ProvidePhotos",
  CarrierRequestAudit = "CarrierRequestAudit",
  Generic = "Generic",
}

export function instanceOfInvoiceChallengeType(value: any): boolean {
  for (const key in InvoiceChallengeType) {
    if (Object.prototype.hasOwnProperty.call(InvoiceChallengeType, key)) {
      if (
        InvoiceChallengeType[key as keyof typeof InvoiceChallengeType] === value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function InvoiceChallengeTypeFromJSON(json: any): InvoiceChallengeType {
  return InvoiceChallengeTypeFromJSONTyped(json, false);
}

export function InvoiceChallengeTypeFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): InvoiceChallengeType {
  return json as InvoiceChallengeType;
}

export function InvoiceChallengeTypeToJSON(
  value?: InvoiceChallengeType | null,
): any {
  return value as any;
}

export function InvoiceChallengeTypeToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): InvoiceChallengeType {
  return value as InvoiceChallengeType;
}
